<template>
  <!--专题详情 -->
  <div class="pcGuide">
      <img src="../images/pcguide.png" alt="">
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      shareSwiper:''
    }
  },
  created(){
    weixin.shareInfo(16,'123','123')
    weixin.shareTitle(16,'12',(data)=>{
      this.shareSwiper = data;
    });
  },
  mounted(){
  },
  methods:{
  }
}
</script>
<style lang="less" scoped>
.pcGuide{
    img{
        width: 100%;
    }
}
</style>





// WEBPACK FOOTER //
// src/share/sharepcGuide.vue